import { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import PreProcess from './PreProcess'
import TrainTestForm from './TrainTestForm'
import UploadEegFiles from './UploadEegFiles'
import UploadMetaData from './UploadMetaData'

const steps = [
  { id: 1, label: 'Upload Metadata' },
  { id: 2, label: 'Upload EEG Files' },
  { id: 3, label: 'Preprocess' },
  { id: 4, label: 'Train/Test' },
]

const Stepper = ({ step, setStep }) => (
  <div className='d-flex flex-column flex-md-row justify-content-between mb-1 position-relative'>
    {steps.map((s) => (
      <div
        key={s.id}
        onClick={() => setStep(s.id)}
        className='d-flex align-items-center ps-2 pe-3 py-2 rounded-pill mx-1 mb-2'
        style={{
          background: step === s.id ? 'var(--primary-gradient)' : step > s.id ? 'white' : '#f8f9fa',
          color: step === s.id ? 'white' : '#6c757d',
          cursor: 'pointer',
          border: `1px solid ${step === s.id ? 'var(--primary-color)' : '#dee2e6'}`,
          transition: '0.2s',
          minWidth: '140px',
        }}
      >
        <div
          className='rounded-circle d-flex align-items-center justify-content-center me-2'
          style={{
            width: '28px',
            height: '28px',
            background: step === s.id ? 'white' : '#dee2e6',
            color: step === s.id ? 'var(--primary-color)' : '#6c757d',
            fontWeight: 'bold',
          }}
        >
          {step > s.id ? '✓' : s.id}
        </div>
        <span style={{ fontSize: '0.9rem', fontWeight: 500 }}>{s.label}</span>
      </div>
    ))}
  </div>
)

const EEGPipeline = () => {
  const [step, setStep] = useState(1)

  return (
    <div className='mt-4'>
      <Container>
        <Row>
          <Col xs={12} lg={10} xl={8} className='mx-auto'>
            <Stepper step={step} setStep={setStep} />
            <div className='dashboard-cards p-4'>
              {step === 1 && <UploadMetaData setStep={setStep} />}
              {step === 2 && <UploadEegFiles setStep={setStep} />}
              {step === 3 && <PreProcess setStep={setStep} />}
              {step === 4 && <TrainTestForm setStep={setStep} />}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default EEGPipeline
